import { LogoutOutlined } from '@ant-design/icons';
import { Tabs } from 'antd';
import { Header } from 'antd/lib/layout/layout';

const HamburgerIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 12H21M3 6H21M3 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const BackArrowIcon = () => (
  <svg width="30" height="30" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 10H5M5 10L9 6M5 10L9 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const UserProfileIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.0013 0.666992C4.3988 0.666992 0.667969 4.39783 0.667969 9.00033C0.667969 13.6028 4.3988 17.3337 9.0013 17.3337C13.6038 17.3337 17.3346 13.6028 17.3346 9.00033C17.3346 4.39783 13.6038 0.666992 9.0013 0.666992ZM9.0013 16.0837C8.07105 16.0836 7.14992 15.9003 6.2905 15.5443C5.43108 15.1882 4.6502 14.6664 3.99246 14.0086C3.33471 13.3508 2.81297 12.5698 2.45703 11.7104C2.10109 10.8509 1.91791 9.92974 1.91797 8.99949C1.91802 8.06924 2.1013 7.14811 2.45735 6.28869C2.81339 5.42927 3.33522 4.64839 3.99305 3.99065C4.65087 3.3329 5.43181 2.81116 6.29127 2.45522C7.15073 2.09928 8.07188 1.9161 9.00214 1.91616C10.8809 1.91627 12.6826 2.6627 14.011 3.99124C15.3394 5.31977 16.0856 7.1216 16.0855 9.00033C16.0854 10.8791 15.3389 12.6808 14.0104 14.0092C12.6819 15.3376 10.88 16.0838 9.0013 16.0837ZM9.0013 9.41699C6.46964 9.41699 4.41797 10.857 4.41797 12.3337C4.41797 13.8103 6.46964 15.2503 9.0013 15.2503C11.533 15.2503 13.5846 13.8103 13.5846 12.3337C13.5846 10.857 11.533 9.41699 9.0013 9.41699ZM9.0013 9.00033C9.66434 9.00033 10.3002 8.73693 10.7691 8.26809C11.2379 7.79925 11.5013 7.16337 11.5013 6.50033C11.5013 5.83728 11.2379 5.2014 10.7691 4.73256C10.3002 4.26372 9.66434 4.00033 9.0013 4.00033C8.33826 4.00033 7.70238 4.26372 7.23353 4.73256C6.76469 5.2014 6.5013 5.83728 6.5013 6.50033C6.5013 7.16337 6.76469 7.79925 7.23353 8.26809C7.70238 8.73693 8.33826 9.00033 9.0013 9.00033Z" fill="currentColor"/>
  </svg>
);

const RocketIcon = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs><clipPath id="header-rocket-clip"><rect width="16" height="16" fill="white" transform="translate(0 0.5)"/></clipPath></defs>
    <g clipPath="url(#header-rocket-clip)">
      <path d="M7.64127 8.14731L3.64258 12.146L4.34968 12.8531L8.34837 8.85441L7.64127 8.14731Z" fill="currentColor"/>
      <path d="M8.49893 15.5C8.43561 15.5002 8.37283 15.4883 8.31393 15.465C8.23202 15.4324 8.1602 15.3786 8.10575 15.3093C8.05131 15.2399 8.01618 15.1574 8.00393 15.07L7.50393 11.57L8.50393 11.43L8.87893 14.065L10.4989 12.76V9.00003C10.4986 8.93423 10.5112 8.869 10.536 8.80808C10.5609 8.74716 10.5976 8.69175 10.6439 8.64503L12.6789 6.61003C13.0983 6.19356 13.4308 5.69806 13.6574 5.15222C13.884 4.60638 14.0001 4.02103 13.9989 3.43003V2.50003H13.0689C12.4779 2.49891 11.8926 2.61499 11.3467 2.84157C10.8009 3.06814 10.3054 3.40071 9.88893 3.82003L7.85393 5.85503C7.80721 5.90137 7.75181 5.93803 7.69089 5.96292C7.62997 5.9878 7.56474 6.00041 7.49893 6.00003H3.73893L2.43393 7.63003L5.06893 8.00503L4.92893 9.00503L1.42893 8.50503C1.3416 8.49278 1.25907 8.45765 1.1897 8.40321C1.12033 8.34877 1.06659 8.27695 1.03393 8.19503C1.00087 8.11254 0.990396 8.02273 1.00358 7.93485C1.01676 7.84697 1.05313 7.76419 1.10893 7.69503L3.10893 5.19503C3.15499 5.13519 3.21401 5.08655 3.28156 5.05278C3.3491 5.01901 3.42342 5.00097 3.49893 5.00003H7.29393L9.17893 3.11003C9.68852 2.59758 10.2948 2.1914 10.9625 1.91503C11.6303 1.63865 12.3462 1.4976 13.0689 1.50003H13.9989C14.2642 1.50003 14.5185 1.60539 14.706 1.79292C14.8936 1.98046 14.9989 2.23481 14.9989 2.50003V3.43003C15.0014 4.15271 14.8603 4.86869 14.5839 5.53645C14.3076 6.2042 13.9014 6.81045 13.3889 7.32003L11.4989 9.20503V13C11.4986 13.0751 11.4813 13.1492 11.4484 13.2167C11.4155 13.2842 11.3679 13.3435 11.3089 13.39L8.80893 15.39C8.72096 15.4606 8.61172 15.4994 8.49893 15.5Z" fill="currentColor"/>
    </g>
  </svg>
);

const AddressIcon = () => (
  <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.00033 8.25C6.58611 8.25 6.25033 8.58579 6.25033 9C6.25033 9.41421 6.58611 9.75 7.00033 9.75V8.25ZM9.50033 9.75C9.91454 9.75 10.2503 9.41421 10.2503 9C10.2503 8.58579 9.91454 8.25 9.50033 8.25V9.75ZM7.00033 11.5833C6.58611 11.5833 6.25033 11.9191 6.25033 12.3333C6.25033 12.7475 6.58611 13.0833 7.00033 13.0833V11.5833ZM9.50033 13.0833C9.91454 13.0833 10.2503 12.7475 10.2503 12.3333C10.2503 11.9191 9.91454 11.5833 9.50033 11.5833V13.0833ZM4.50033 8.25C4.08611 8.25 3.75033 8.58579 3.75033 9C3.75033 9.41421 4.08611 9.75 4.50033 9.75V8.25ZM4.50866 9.75C4.92287 9.75 5.25866 9.41421 5.25866 9C5.25866 8.58579 4.92287 8.25 4.50866 8.25V9.75ZM4.50033 11.5833C4.08611 11.5833 3.75033 11.9191 3.75033 12.3333C3.75033 12.7475 4.08611 13.0833 4.50033 13.0833V11.5833ZM4.50866 13.0833C4.92287 13.0833 5.25866 12.7475 5.25866 12.3333C5.25866 11.9191 4.92287 11.5833 4.50866 11.5833V13.0833ZM12.0837 4.83333V14.8333H13.5837V4.83333H12.0837ZM11.167 15.75H2.83366V17.25H11.167V15.75ZM1.91699 14.8333V4.83333H0.416992V14.8333H1.91699ZM2.83366 3.91667H4.50033V2.41667H2.83366V3.91667ZM9.50033 3.91667H11.167V2.41667H9.50033V3.91667ZM2.83366 15.75C2.3274 15.75 1.91699 15.3396 1.91699 14.8333H0.416992C0.416992 16.168 1.49897 17.25 2.83366 17.25V15.75ZM12.0837 14.8333C12.0837 15.3396 11.6733 15.75 11.167 15.75V17.25C12.5017 17.25 13.5837 16.168 13.5837 14.8333H12.0837ZM13.5837 4.83333C13.5837 3.49865 12.5017 2.41667 11.167 2.41667V3.91667C11.6733 3.91667 12.0837 4.32707 12.0837 4.83333H13.5837ZM1.91699 4.83333C1.91699 4.32707 2.3274 3.91667 2.83366 3.91667V2.41667C1.49897 2.41667 0.416992 3.49865 0.416992 4.83333H1.91699ZM7.00033 9.75H9.50033V8.25H7.00033V9.75ZM7.00033 13.0833H9.50033V11.5833H7.00033V13.0833ZM6.16699 2.25H7.83366V0.75H6.16699V2.25ZM7.83366 4.08333H6.16699V5.58333H7.83366V4.08333ZM6.16699 4.08333C5.66073 4.08333 5.25033 3.67293 5.25033 3.16667H3.75033C3.75033 4.50135 4.8323 5.58333 6.16699 5.58333V4.08333ZM8.75033 3.16667C8.75033 3.67293 8.33992 4.08333 7.83366 4.08333V5.58333C9.16835 5.58333 10.2503 4.50135 10.2503 3.16667H8.75033ZM7.83366 2.25C8.33992 2.25 8.75033 2.66041 8.75033 3.16667H10.2503C10.2503 1.83198 9.16835 0.75 7.83366 0.75V2.25ZM6.16699 0.75C4.8323 0.75 3.75033 1.83198 3.75033 3.16667H5.25033C5.25033 2.66041 5.66073 2.25 6.16699 2.25V0.75ZM4.50033 9.75H4.50866V8.25H4.50033V9.75ZM4.50033 13.0833H4.50866V11.5833H4.50033V13.0833Z" fill="currentColor"/>
  </svg>
);

const WalletSidebarIcon = () => (
  <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.8333 14.6663H3.16667C2.72464 14.6663 2.30072 14.4907 1.98816 14.1782C1.67559 13.8656 1.5 13.4417 1.5 12.9997V5.49967C1.5 5.05765 1.67559 4.63372 1.98816 4.32116C2.30072 4.0086 2.72464 3.83301 3.16667 3.83301H14.8333C15.2754 3.83301 15.6993 4.0086 16.0118 4.32116C16.3244 4.63372 16.5 5.05765 16.5 5.49967V12.9997C16.5 13.4417 16.3244 13.8656 16.0118 14.1782C15.6993 14.4907 15.2754 14.6663 14.8333 14.6663Z" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M12.7507 9.66634C12.6401 9.66634 12.5342 9.62244 12.456 9.5443C12.3779 9.46616 12.334 9.36018 12.334 9.24967C12.334 9.13917 12.3779 9.03319 12.456 8.95505C12.5342 8.87691 12.6401 8.83301 12.7507 8.83301C12.8612 8.83301 12.9671 8.87691 13.0453 8.95505C13.1234 9.03319 13.1673 9.13917 13.1673 9.24967C13.1673 9.36018 13.1234 9.46616 13.0453 9.5443C12.9671 9.62244 12.8612 9.66634 12.7507 9.66634Z" fill="currentColor" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 3.8333V2.66913C13.9999 2.41372 13.9412 2.16174 13.8282 1.93265C13.7153 1.70356 13.5512 1.50349 13.3487 1.34789C13.1461 1.1923 12.9105 1.08533 12.66 1.03527C12.4096 0.985197 12.151 0.993363 11.9042 1.05913L2.7375 3.5033C2.38254 3.59789 2.06878 3.8071 1.84499 4.0984C1.6212 4.38971 1.49992 4.74679 1.5 5.11413V5.49997" stroke="currentColor" strokeWidth="1.5"/>
  </svg>
);

const HistoryIcon = () => (
  <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.7505 8.00017C17.7507 9.5754 17.2909 11.1164 16.4275 12.4339C15.5641 13.7515 14.3347 14.7882 12.8903 15.4168C11.446 16.0454 9.84945 16.2385 8.29685 15.9724C6.74426 15.7063 5.30316 14.9926 4.15053 13.9189C4.0287 13.8062 3.95663 13.6497 3.95018 13.4838C3.94374 13.318 4.00344 13.1564 4.11616 13.0345C4.22887 12.9127 4.38537 12.8406 4.55123 12.8342C4.71708 12.8277 4.8787 12.8874 5.00053 13.0002C6.14539 14.0667 7.6214 14.7083 9.18221 14.8179C10.743 14.9275 12.2942 14.4985 13.5769 13.6024C14.8596 12.7064 15.7961 11.3975 16.2302 9.89426C16.6643 8.39104 16.5698 6.78439 15.9623 5.34248C15.3548 3.90057 14.2711 2.71062 12.8922 1.97125C11.5133 1.23188 9.92245 0.987812 8.38527 1.27978C6.8481 1.57175 5.45756 2.3821 4.44574 3.57557C3.43392 4.76904 2.86203 6.27344 2.82553 7.83767H3.76303C3.87316 7.83723 3.98145 7.8659 4.07694 7.92078C4.17243 7.97566 4.25172 8.05479 4.30678 8.15017C4.36164 8.24518 4.39052 8.35296 4.39052 8.46267C4.39052 8.57238 4.36164 8.68015 4.30678 8.77517L2.86303 11.2752C2.80852 11.3714 2.72947 11.4514 2.63395 11.507C2.53842 11.5627 2.42984 11.592 2.31928 11.592C2.20872 11.592 2.10014 11.5627 2.00462 11.507C1.90909 11.4514 1.83004 11.3714 1.77553 11.2752L0.331781 8.77517C0.276926 8.68015 0.248047 8.57238 0.248047 8.46267C0.248047 8.35296 0.276926 8.24518 0.331781 8.15017C0.386846 8.05479 0.466136 7.97566 0.561622 7.92078C0.657108 7.8659 0.7654 7.83723 0.875531 7.83767H1.58178C1.65761 5.73039 2.55347 3.73606 4.07841 2.27973C5.60336 0.823393 7.63679 0.0202333 9.74533 0.0414246C11.8539 0.0626158 13.8707 0.906482 15.3661 2.39317C16.8615 3.87986 17.7171 5.89179 17.7505 8.00017ZM12.613 11.5127C12.7152 11.3831 12.7621 11.2185 12.7433 11.0546C12.7246 10.8906 12.6418 10.7408 12.513 10.6377L9.62553 8.32517V3.00017C9.62553 2.83441 9.55969 2.67544 9.44248 2.55823C9.32526 2.44102 9.16629 2.37517 9.00053 2.37517C8.83477 2.37517 8.6758 2.44102 8.55859 2.55823C8.44138 2.67544 8.37553 2.83441 8.37553 3.00017V8.62517C8.37597 8.71904 8.39754 8.81162 8.43866 8.89602C8.47977 8.98041 8.53937 9.05446 8.61303 9.11267L11.738 11.6127C11.848 11.7009 11.9846 11.7493 12.1255 11.7502C12.2194 11.7497 12.312 11.7282 12.3964 11.687C12.4808 11.6459 12.5548 11.5863 12.613 11.5127Z" fill="currentColor"/>
  </svg>
);
import logo from 'Assets/icon/Logo.svg';
import images from 'Assets/images';
import Dropdown from 'Components/Dropdown';
import LanguagePicker from 'Components/LanguagePicker';
import MenuItemList from 'Components/MenuItemList';
import { ItemBaseModel } from 'Components/Models';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import LoadingBar, { LoadingBarRef } from 'react-top-loading-bar';
import { MainPageEnum } from 'Routes';
import { layoutUtilitiesSliceSelectors } from 'Stores/layout-utilities';
import { profileSliceActions, profileSliceSelectors } from 'Stores/profile';
import { PROFILE_TYPES } from 'Utilities/constants';
import { classPrefix } from 'Utilities/global';
import { isVenusLogin, logUserOut } from 'Utilities/util';
import { getStoredPartner, isWebView } from 'Utilities/webview';
import { TABS_HEADER } from '../Constants';
import './index.scss';
interface PropsModel {
  tabs: Array<ItemBaseModel>;
  onChangeTab?: (key: string) => void;
  defaultActiveKey?: string;
  isShowTab?: boolean;
}

const TopNav = (props: PropsModel) => {
  const { tabs, defaultActiveKey, onChangeTab = () => {}, isShowTab } = props;
  const dispatch = useDispatch();
  const profile = useSelector(profileSliceSelectors.get);
  const [scroll, setScroll] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const loadingRef = useRef<LoadingBarRef>(null);
  // antd's Dropdown portals its overlay into document.body by default,
  // positioned with position: absolute relative to the DOCUMENT — so it
  // scrolls away with the page instead of staying anchored to the (now
  // position: fixed) hamburger button. Rendering it inside the fixed header
  // container instead makes its absolute positioning relative to that fixed
  // ancestor, which doesn't move on scroll.
  const webviewHeaderRef = useRef<HTMLDivElement>(null);
  const { processingNavbar, currentPath } = useSelector(
    layoutUtilitiesSliceSelectors.get
  );

  const { t } = useTranslation();
  const webView = isWebView();
  const navigate = useNavigate();

  const partnerRaw = getStoredPartner() ?? '';
  const isVikkiPartner = partnerRaw.toLowerCase() === 'vikki_bank';
  const isHomeScreen = currentPath === MainPageEnum.Swift247;

  const closeWebView = () => {
    const message = JSON.stringify({ event: 'CLOSED' });
    const rn = (window as any).ReactNativeWebView;
    if (rn) {
      rn.postMessage(message);
    } else {
      window.parent.postMessage(message, '*');
    }
  };

  // Only exit the webview from the home screen — everywhere else, step back
  // through the in-app navigation history first (react-router's own session
  // history, scoped to this webview's own navigation stack).
  const handleWebViewBack = () => {
    if (isHomeScreen) {
      closeWebView();
      return;
    }
    navigate(-1);
  };

  const data = [
    {
      text: t('profile_section_title'),
      icon: <UserProfileIcon />,
      link: '/my-profile'
    },
    {
      text: t('menu_item_place_order'),
      icon: <RocketIcon />,
      link: '/'
    },
    {
      text: t('menu_item_order_history'),
      icon: <HistoryIcon />,
      link: '/my-orders'
    },
    {
      text: t('menu_item_address_book'),
      icon: <AddressIcon />,
      link: '/address'
    },
    {
      text: t('topup_prepayment'),
      icon: <WalletSidebarIcon />,
      link: '/top-up'
    },
    {
      text: t('menu_item_logout'),
      icon: <LogoutOutlined />,
      action: () => {
        logUserOut();
      }
    }
  ];

  useEffect(() => {
    if (
      (currentPath === MainPageEnum.CargoDirect ||
        currentPath === MainPageEnum.Swift247 ||
        Object.keys(profile.data || {})?.length == 0) &&
      profile.fetchingStatus !== 'pending'
    ) {
      dispatch(profileSliceActions.getting({}));
    }
  }, [currentPath]);

  useEffect(() => {
    if (processingNavbar) {
      loadingRef?.current?.continuousStart(20, 2);
    } else {
      loadingRef?.current?.complete();
    }
  }, [processingNavbar]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const { TabPane } = Tabs;

  const renderTab = () => {
    if (!tabs?.length || !isShowTab) {
      return <></>;
    }

    const onTabClick = (tab: string) => {
      const isPageTab = TABS_HEADER.some(tab => tab.field === currentPath);
      if (!isPageTab) {
        onChangeTab(tab);
      }
    };

    const listTabs = tabs.map(tab => {
      return !tab.isHide && (
        <TabPane
          tab={
            <>
              <img src={tab.img} alt="tab" />
              <span>{t(tab?.name || '')}</span>
            </>
          }
          key={tab?.field}
          className="tab-pane-header"
          disabled={tab?.disabled}
        ></TabPane>
      );
    });
    return (
      <Tabs
        activeKey={defaultActiveKey}
        type="card"
        onChange={onChangeTab}
        onTabClick={onTabClick}
      >
        {listTabs}
      </Tabs>
    );
  };

  const handleScroll = () => {
    if (window.pageYOffset > 75) {
      setScroll(true);
      return;
    }
    setScroll(false);
  };

  const webviewMenuOverlay = (
    <div className={`${classPrefix}-header-menu-list webview-hamburger-menu`}>
      <div className="webview-hamburger-menu-language">
        <LanguagePicker />
      </div>
      <MenuItemList
        items={data}
        onItemClick={() => setDropdownOpen(false)}
      />
    </div>
  );

  if (webView) {
    return (
      <>
        <div ref={webviewHeaderRef} className={`${classPrefix}-header-container webview-header-container`}>
          <Header className="header webview-header">
            <div className="header-top-wrap webview-header-top-wrap">
              <div className="webview-logo-row">
                <button
                  className={`webview-back-btn${isVikkiPartner ? ' webview-back-btn--vikki' : ''}`}
                  onClick={handleWebViewBack}
                >
                  <BackArrowIcon />
                </button>
                <div className="webview-logo-center">
                  <img src={logo} alt="" height="40" />
                </div>
                {profile ? (
                  <Dropdown
                    className={'cursor-pointer'}
                    arrow
                    placement="bottomRight"
                    // antd's default trigger is ['hover'] — on touch devices
                    // (this menu only renders inside the webview) hover is
                    // simulated inconsistently, so the first tap sometimes
                    // only registers as "hover enter" and does nothing,
                    // needing a second tap to actually open/select. Explicit
                    // 'click' trigger makes every tap register immediately.
                    trigger={['click']}
                    getPopupContainer={() => webviewHeaderRef.current || document.body}
                    open={dropdownOpen}
                    onOpenChange={setDropdownOpen}
                    overlay={webviewMenuOverlay}
                  >
                    <div className="webview-hamburger-btn">
                      <HamburgerIcon />
                    </div>
                  </Dropdown>
                ) : <span />}
              </div>
            </div>
          </Header>

          <LoadingBar
            color="#b3446d"
            containerClassName={!scroll ? 'processing-header' : ''}
            ref={loadingRef}
          />
        </div>
      </>
    );
  }

  return (
    <>
      <div
        className={`${classPrefix}-header-container ${
          tabs?.length ? 'header-with-tab' : ''
        }`}
      >
        <Header className="header">
          <div className="header-top-wrap">
            <div className="logo">
              <Link to={'https://swift247.vn'}>
                <img src={logo} alt="" height="44" />
              </Link>
            </div>
            <div className={'d-flex align-items-center'}>
              <LanguagePicker />
              {profile && (
                <Dropdown
                  className={'cursor-pointer'}
                  arrow
                  placement="bottomRight"
                  open={dropdownOpen}
                  onOpenChange={setDropdownOpen}
                  overlay={
                    <MenuItemList
                      className={`${classPrefix}-header-menu-list`}
                      items={data}
                      onItemClick={() => setDropdownOpen(false)}
                    />
                  }
                >
                  <div className={'d-flex align-items-center'}>
                    <img src={images.profilerIconUrl} alt={''} />
                    <span className={'text-white fw-600 ml-2 fs-p-md'}>
                      {profile?.data.type === PROFILE_TYPES.personal
                        ? profile?.data.name
                        : profile?.data.companyName}
                    </span>
                  </div>
                </Dropdown>
              )}
            </div>
          </div>

          <div className="tabs-header-container">{renderTab()}</div>
        </Header>

        <LoadingBar
          color="#b3446d"
          containerClassName={!scroll ? 'processing-header' : ''}
          ref={loadingRef}
        />
      </div>
    </>
  );
};

export default TopNav;
